import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { FC, Fragment } from "react";
import Select, { components } from "react-select";

type Option = {
  value: string;
  label: string;
};

export type MultiSelectCategorysprops = {
  options: {
    label: string;
    options: Option[];
  }[];
  label: string;
  onChange: any;
  value?: any[];
  error?: string;
  span?: string;
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
      {/* Cambia el color y estilo del ícono */}
    </components.DropdownIndicator>
  );
};

export const MultiSelectCategorys: FC<MultiSelectCategorysprops> = ({
  options,
  label,
  onChange,
  value = [],
  error,
  span,
}) => {
  return (
    <Fragment>
      <div className="w-full max-w-full mx-auto">
        <div className="flex justify-between">
          <label
            htmlFor="items"
            className="block text-gray-700 text-sm font-medium"
          >
            {label}
          </label>
          <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
        </div>

        <Select
          id="items"
          isMulti
          name="items"
          options={options}
          value={value}
          onChange={onChange}
          classNamePrefix="react-select"
          placeholder="Nada seleccionado"
          components={{ DropdownIndicator }}
          hideSelectedOptions={false} // This keeps selected options in the dropdown
          maxMenuHeight={200} // Limit dropdown height for better scroll
          menuPlacement="auto" // Auto position the dropdown
          styles={{
            control: (provided, state) => ({
              ...provided,
              borderRadius: "0.375rem", // rounded-md
              borderColor: "#D1D5DB", // border-gray-300
              boxShadow: "none",
              "&:hover": {
                borderColor: "var(--primary-500)", // border-gray-400 en hover
              },
              // Apply additional styles to mimic ListboxButton
              backgroundColor: "#FFFFFF", // bg-white
              cursor: "default", // cursor-default
              textAlign: "left", // text-left
              fontSize: "0.875rem", // sm:text-sm
              lineHeight: "1.5rem", // sm:leading-6
              minHeight: "38px", // Ensure minimum height
              maxHeight: "120px", // Limit maximum height to prevent excessive growth
              overflowY: "auto", // Enable vertical scroll in control
            }),

            menu: (provided) => ({
              ...provided,
              marginTop: "0.25rem", // mt-1
              borderRadius: "0.375rem", // rounded-md
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", // shadow-lg
              maxHeight: "200px", // Limit dropdown height
              width: "100%", // w-full
              overflowY: "auto", // overflow-auto
              zIndex: 9999, // Ensure dropdown appears above other elements
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? "#E0E7FF" // bg-indigo-100 for selected items
                : state.isFocused
                  ? "#E5E7EB" // bg-gray-100 for focused items
                  : "#FFFFFF", // bg-white for normal items
              color: state.isSelected
                ? "#4338CA" // text-indigo-700 for selected items
                : state.isFocused
                  ? "#111827" // text-gray-900 for focused items
                  : "#1F2937", // text-gray-700 for normal items
              padding: "0.5rem 1rem", // py-2 pl-3 pr-9
              cursor: "pointer", // cursor-pointer
              fontWeight: state.isSelected ? "600" : "400", // font-semibold for selected
              opacity: state.isSelected ? 0.7 : 1, // Slightly transparent for selected items
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: "#E0E7FF", // bg-indigo-100
              borderRadius: "0.375rem", // rounded-md
              color: "#4338CA", // text-indigo-700
              padding: "0.1rem 0.5rem",
              margin: "2px", // Add some margin between values
              maxWidth: "150px", // Limit width of individual values
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              color: "#4338CA", // text-indigo-700
              fontSize: "0.75rem", // Smaller font size for values
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              color: "#4338CA", // text-indigo-700
              "&:hover": {
                backgroundColor: "#C7D2FE", // bg-indigo-200
                color: "#3730A3", // text-indigo-900
              },
              padding: "0 4px", // Smaller padding for remove button
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: "2px 8px", // Reduce padding
              maxHeight: "100px", // Limit height of value container
              overflowY: "auto", // Enable scroll in value container
            }),
            input: (provided) => ({
              ...provided,
              margin: "0", // Remove margin from input
            }),
          }}
        />
        {error && <p className={`text-sm text-red-600`}>{error}</p>}
      </div>
    </Fragment>
  );
};
